<template>
    <div class="backend-container deal-share deal-search">
        <BackendHeader />
        <h1>Deal Search</h1>
        <div class="deal-search-search-section">
            <div class="deal-search-one">
                <div>
                    <div class="input-label">Search Text</div>
                    <div class="input-container"><input v-model="searchQuery" placeholder="Search..." @input="clear()" /></div>
                </div>
            </div>
            <div class="deal-search-two">
                <div>
                    <div class="input-label">Min Price</div>
                    <div class="input-container"><input v-model="minPrice" placeholder="Min Price" @input="clear()" /></div>
                </div>
                <div>
                    <div class="input-label">Max Price</div>
                    <div class="input-container"><input v-model="maxPrice" placeholder="Max Price" @input="clear()" /></div>
                </div>
            </div>
            <div class="deal-search-two">
                <div>
                    <div class="input-label">Min % Off</div>
                    <div class="input-container"><input v-model="minPctOff" placeholder="Min % Off" @input="clear()" /></div>
                </div>
                <div>
                    <div class="input-label">Max % Off</div>
                    <div class="input-container"><input v-model="maxPctOff" placeholder="Max % Off" @input="clear()" /></div>
                </div>
            </div>
            <div class="deal-search-one">
                <div class="input-checkbox-container"><input type="checkbox" v-model="onlyPrime" @change="clear()" />Prime Only</div>
            </div>
        </div>
        <div class="deal-search-buttons">
            <button @click="search()" :disabled="!searchQuery" class="button">GENERATE</button>
        </div>
        <div>
            <textarea v-model="generatedLink" readonly ref="textarea" />
        </div>
        <div class="deal-search-buttons" v-show="generatedLink">
            <a v-show="!copied" class="promo-copy-code" @click="copyToClipboard()" >COPY</a>
            <a v-show="copied" class="promo-copy-code copied" >COPIED</a>
            <a :href="generatedLink" target="_blank">GO TO DEAL</a>
        </div>
    </div>
</template>

<script>

import api from '@/api'
import settings from '@/settings'
import BackendHeader from '@/components/BackendHeader'

export default {
        name: "dealsearch",
        data() {
            return {
                searchQuery: null,
                minPrice: null,
                maxPrice: null,
                minPctOff: null,
                maxPctOff: null,
                onlyPrime: true,

                generatedLink: null,
                copied: false
            };
        },
        methods: {
            search() {

                this.generatedLink = null;

                setTimeout(() => {

                    let url = `https://www.amazon.com/s?k=${this.searchQuery}&rh=`;
                    //free shipping
                    url += 'p_76:2661625011'

                    //min max
                    if (this.minPrice && this.maxPrice) {
                        url += `,p_36:${this.convertToMilitaryStyle(this.minPrice)}-${this.convertToMilitaryStyle(this.maxPrice)}`
                    }
                    else if (this.minPrice) {
                        url += `,p_36:${this.convertToMilitaryStyle(this.minPrice)}-`
                    }
                    else if (this.maxPrice) {
                        url += `,p_36:-${this.convertToMilitaryStyle(this.maxPrice)}`
                    }

                    //pct off
                    if (this.minPctOff && this.maxPctOff) {
                        url += `,p_75:${this.convertForPctOff(this.minPctOff)}-${this.convertForPctOff(this.maxPctOff)}`
                    }
                    else if (this.minPctOff) {
                        url += `,p_75:${this.convertForPctOff(this.minPctOff)}-`
                    }
                    else if (this.maxPctOff) {
                        url += `,p_75:-${this.convertForPctOff(this.maxPctOff)}`
                    }

                    //prime only
                    if (this.onlyPrime) {
                        url += `,p_85:2470955011`
                    }

                    this.generatedLink = url;

                }, 500);

            },
            convertToMilitaryStyle(input) {
                // Convert input to a number if it's a string
                const amount = typeof input === 'string' ? parseFloat(input) : input;

                // Round the value to the nearest hundredth
                const roundedValue = Math.round(amount * 100) / 100;

                // Multiply the rounded value by 100 and convert to an integer
                const value = Math.round(roundedValue * 100);

                return value.toString();
            },
            convertForPctOff(input) {
                // Convert input to a number if it's a string
                const amount = typeof input === 'string' ? parseFloat(input) : input;

                // Round the value to the nearest hundredth
                const roundedValue = Math.round(amount * 100) / 100;

                // Multiply the rounded value by 100 and convert to an integer
                const value = Math.round(roundedValue);

                return value.toString();
            },
            copyToClipboard() {
                var copyText = this.$refs.textarea;
                copyText.select();
                document.execCommand("copy");
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 2000);
            },
            clear(){
                this.generatedLink = null;
            }
        },
        mounted() {

        },
        components: {
            BackendHeader
        }
};
</script>
<style>
    .deal-search .input-label {
        font-size: 10pt;
    }

    .deal-search-search-section {
        display: flex;
        flex-direction: column;
        gap: 7px;
    }

    .deal-search-two {
        display: flex;
        width: 350px;
        gap: 15px;
    }

    .deal-search textarea {
        height: 110px;
        width: 350px;
    }

    .deal-search .input-container input {
        height: 30px;
        display: block;
        width: 100%;
        padding-left: 5px;
    }

    .deal-search-buttons {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .deal-search-buttons {
        display: flex;
        align-items: center;
        gap: 35px;
    }
</style>